import React from 'react'
import './About.css';

function About() {
  return (
    <>
    
    <div className="about">
    <h1>About Us</h1>
  <p>
    <b>Aphrodite</b>, greek goddess of beauty.<br></br><br></br>
    <p2>"We let you feel beautiful , Look Beautiful and Be Beautiful Inside and Out."<br></br>
    <br></br>ADORE IT. OFFER IT . LIVE IT.</p2>
    <br></br>
    <br></br>
    We appreciate the certainty, quality, and beauty with which all of you carry on with your life. We need to be your buddy as you go up against numerous symbols and find your own character and individual style.<br></br><br></br>
  {/* <h3> What we believe in?</h3> */}
  We realize that looking for healthy skin, makeup, and other magnificent items can be a mind-boggling background.<br></br><br></br>
  Aphrodite represents a solid, new account in beauty, one that lifts up all outflows of independence. We accept there is no single format for beauty. Every lady is particularly wonderful and we might want to be an accomplice in her voyage to discover and improve it.
  {/* <h3>How are we different?</h3> */}
  We make beauty easy. We offer you the advantage of decisions between what is beneficial for you and what’s useful for you.
  <br></br>
  <br></br>
  We trust you appreciate shopping and on the off chance that you have an inquiry, proposals, solicitations, or analysis, don’t hesitate to get in touch with us.
  <br></br><br></br><br></br></p>
  
    </div>
    <br></br><br></br>
    </>
  )
}

export default About